import URL from './url'
import http from '@/utils/httpUtils'
import { appId } from '@/env'
import { mcJsAuthConfig, mcRequestAuthCode } from '@/utils/mcSdkUtils'
import {
  setItem,
  getItem,
  removeItem,
  getSearchValueByKey
} from '@/utils/comUtils'
export default {
  // 获取钉钉token
  /*  1: 魔点校园来源 (默认)
   *  2: 魔方来源
   *  5: 健康防疫来源
   *  7: 魔方宿舍来源
   *  8: 亲情通话
   *  9: 魔方班牌
   * 12: 学生用餐
   * 98: 微信公众号来源
   * 99: 网页魔点校园来源
   * 100: 微信公众号--微信平台
   */
  dingLogin(params) {
    return new Promise((resolve, reject) => {
      let _corpId = params.dingCorpId
      let _userInfo = {}
      switch (params.platformSource) {
        case '7':
        case '2':
        case '9':
        case '8':
        case '12':
          // 魔方版本
          mcRequestAuthCode(_corpId)
            .then(code => {
              return http.post(URL.API_DING_ZJCUBE_INFO, {
                corpId: _corpId,
                platformSource: params.platformSource,
                code
              })
            })
            .then(cubeRes => {
              delete params.platformSource
              _userInfo = (cubeRes || {}).data || {}
              return http.post(URL.API_DING_ZJCUBE_CHECK_INIT, { params })
            })
            .then(init => {
              const _status = (init || {}).status
              // 1:正在初始化 2:  已初始化完成 3: 已初始化完成,但通录录同步失败
              switch (_status) {
                case 1:
                  const _err = { message: '机构初始化中，请稍后重试' }
                  reject(_err)
                  break
                case 2:
                  return http.post(URL.API_DING_TOKEN, params)
                case 3:
                  return http.post(URL.API_DING_TOKEN, params) // 暂时和2一样
              }
              // 获取免登用户信息
            })
            .then(config => {
              if (config.result && config.result === 'XE01000500005') {
                // 企业未授权
                reject(config)
              } else {
                // 通过钉钉签名获取、配置钉钉sdk 获取免登CODE
                config.corpId = _corpId
                setItem('campusAuth', config || {})
                setItem('agentId', (config || {}).agentId || '')
                return mcJsAuthConfig(config)
              }
            })
            .then(config => {
              config.dingCorpId = _corpId
              config.code && delete config.code
              config.userDingId = _userInfo.userId
              const platformSource = getSearchValueByKey('platformSource')
              // 后端约定，8-亲情通话 以后的套餐都需要增加appId传参
              if (['8', '12'].includes(platformSource)) {
                config.appId = appId[platformSource || '1']
              }
              // 获取免登用户信息
              return http.post(URL.API_USER_INFO, config)
            })
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              // 错误上报
              try {
                http.post(URL.API_COMMAND_LOG, {
                  corpId: _corpId,
                  platformSource: params.platformSource,
                  appType: 1,
                  errorMsg: (err && err.message) || '未捕获到确切错误',
                  page: 'ding.js'
                })
              } catch (e) {}
              reject(err)
            })
          break
        case '98':
          // 微信公众号版本
          // 保留--cubeorg版本
          // const param = {
          //   platformSource: getItem('platformSource'),
          //   cubeOrgId: getItem('cubeOrgId') || '',
          //   cubeUserId: getItem('cubeUserId') || '',
          //   token: getItem('wechatToken') || ''
          // }
          const param = {
            platformSource: getItem('platformSource'),
            dingUserId: getItem('dingUserId') || '',
            dingCorpId: _corpId,
            token: getItem('wechatToken') || ''
          }
          // 先判断机构有没有开通魔点校园 获取免登用户信息
          http
            .post(URL.API_LEARN_CODE_USER_INFO, param)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })

          break
        case '99':
          // 网页版本-获取免登code
          http
            .post(URL.API_DING_TOKEN, params)
            .then(config => {
              config.dingCorpId = _corpId
              // 获取免登用户信息
              return http.post(URL.API_USER_INFO, config)
            })
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
          break
        case '100':
          // 如果是从微信绑定跳转过来的，绑定接口已经获取token了，不用重新获取
          const isFromBind = getItem('isFromBind')
          const token = getItem('TOKEN') || {}
          if (isFromBind) {
            resolve(token)
            removeItem('isFromBind')
            return
          }
          // 微信平台获取用户信息
          const wxParams = {
            code: getItem('weixinCode'),
            appId: getItem('weixinAppId'),
            platformSource: 100,
            openId: token.openId || ''
          }
          // 先判断机构有没有开通魔点校园 获取免登用户信息
          http
            .post(URL.API_WECHAT_GET_USERINFO, wxParams)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
          break
        default:
          // 默认-获取免登code
          http
            .post(URL.API_DING_TOKEN, params)
            .then(config => {
              if (config.result && config.result === 'XE01000500005') {
                // 企业未授权
                reject(config)
              } else {
                // 通过钉钉签名获取、配置钉钉sdk 获取免登CODE
                config.corpId = _corpId
                setItem('campusAuth', config || {})
                setItem('agentId', (config || {}).agentId || '')
                return mcJsAuthConfig(config)
              }
            })
            .then(config => {
              config.dingCorpId = _corpId
              // 获取免登用户信息
              return http.post(URL.API_USER_INFO, config)
            })
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              // 错误上报
              try {
                http.post(URL.API_COMMAND_LOG, {
                  corpId: _corpId,
                  platformSource: params.platformSource,
                  appType: 1,
                  errorMsg: (err && err.message) || '未捕获到确切错误',
                  page: 'ding.js'
                })
              } catch (e) {}
              reject(err)
            })
      }
    })
  },
  weixinLogin(params) {
    return http.post(URL.API_USER_INFO, params)
  },
  // 企业通讯录同步
  dingStartUserSync() {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_START_USER_SYNC)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 企业通讯录同步状态
  getUserSynStatus() {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING__SYNC_STATUS)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询家校通讯录同步状态
  getSchoolSynStatus() {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_SYNC_STATUS)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 删除机构成员人员数据
  dingRemoveUserFace(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_USER_REMOVW_FACE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生基本信息
  dingGetStudentBaseInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_STUDENT_BASE_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生信息
  dingGetStudentInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_STUDENT_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询老师信息
  dingGetTeacherInfo(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_TEACHER_INFO, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询校区信息(旧列表)
  dingGetCapmusList() {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_CAPMUS_LIST)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询校区信息(新列表)
  dingGetNewCapmusList() {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_CAPMUS_LIST_NEW)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学段信息(列表)
  dingGetPeriodList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_PERIOD_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取班级详情
  dingGetSchoolClassDetail(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_SCHOOL_CLASS_DETAIL, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询年级信息(列表)
  dingGetGradeList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_GRADE_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询班级信息(列表)
  dingGetClassList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_CLASS_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生信息(列表)
  dingGetStudentList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_STUDENT_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生信息-分校区(列表)
  dingPostStudentList(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_SEATRCH_STUDENT_LIST, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 钉钉ID转化为部门ID API_DING_TRANSFORM_DEPT
  dingPostTranstormDeptId(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_TRANSFORM_DEPT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 部门Id转化为钉钉Id API_DING_TRANSFORM_TPDEPT
  dingPostTranstormDingDeptId(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_DING_TRANSFORM_TPDEPT, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 魔点人员id转钉人员id
  getMemberIdTpIdRelation(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_MEMBERID_TPIDRELATION, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 钉人员id转魔点人员id
  getTpIdMemberIdRelation(params) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_TPIDME_MBERIDRELATION, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 班主任-学生列表api
  getStudentFamilyFaceCount(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_SCHOOL_FACE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 根据设备第三方id获取设备id
  getDeviceByTpId(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_DEVICE_BY_TPID, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取企业下的自定义空间
  getCustomSpace(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_GET_CORP_USER_CUSTOM_SPACE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 是否魔方应用
  judgeOrgIsCube(params) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_CUBE_JUDGE_ORG_IS_CUBE, params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 移动浙学码cubeUserId-dingUserId
  learnCodeUserMapping(params) {
    return http.get(URL.API_LEARN_CODE_USER_MAPPING, params)
  }
}
